import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
function getHumanFileSize(bytes) {
  var thresh = 1000;
  if (bytes < thresh) {
    return "".concat(bytes, " B");
  }
  var units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (bytes >= thresh);
  return "".concat(bytes.toFixed(1), " ").concat(units[u]);
}
export default getHumanFileSize;